import { BackendErrorCode } from '~/apiClient';

/** The purchase-block causes the site can describe. */
const PURCHASE_BLOCK_REASONS = [
    BackendErrorCode.CantPerformInspectionExpiredNotExportable,
    BackendErrorCode.CantPerformInspectionExpiringSoonNotExportable,
    BackendErrorCode.CantPerformEuTypeApprovalNotRegistrableInSpain,
    BackendErrorCode.CantPerformRegioDecretoNotRegistrableOutsideSpain,
] as const satisfies readonly BackendErrorCode[];

type PurchaseBlockReason = (typeof PURCHASE_BLOCK_REASONS)[number];

const PURCHASE_BLOCK_REASON_SET = new Set<BackendErrorCode>(PURCHASE_BLOCK_REASONS);

export const isPurchaseBlockReason = (code: BackendErrorCode | null | undefined): code is PurchaseBlockReason =>
    !!code && PURCHASE_BLOCK_REASON_SET.has(code);

type GetPurchaseBlockReasonsParams = {
    purchaseBlockReasons: BackendErrorCode[] | undefined;
    cantReason: BackendErrorCode | null | undefined;
};

/**
 * Every purchase block the backend reports for the viewer, causes the site does not know yet included, so they still
 * count as a block. Falls back on the cant reason while a backend without the list is live: the site deploys first.
 */
export const getPurchaseBlockReasons = ({ purchaseBlockReasons, cantReason }: GetPurchaseBlockReasonsParams): BackendErrorCode[] => {
    if (purchaseBlockReasons?.length) return purchaseBlockReasons;

    return isPurchaseBlockReason(cantReason) ? [cantReason] : [];
};
